import * as React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CircularProgress, FormControl, InputBase, MenuItem, Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Controller } from "react-hook-form";
import { LoadingButton } from "@mui/lab";


const ButtonStyle = styled(LoadingButton)({
  backgroundColor: "#6200EE",
  textTransform: "lowercase !important",
  color: "white",
  fontWeight: 700,
  fontSize: "17px",
  borderRadius: "14px",
  maxWidth: "155px",
  minWidth: "100px",
  "&:hover": {
    backgroundColor: "#6200EE",
    color: "white",
  }
});


const FastMarketingCollapsItem = ({ average, control }) => {
  return (
    <React.Fragment>
      <Controller
        name="locationCount"
        control={control}
        render={({ field: { value, onChange } }) => (
          <InputBase
            sx={{
              mt: 1,
              width: "60px",
              backgroundColor: "#F2E9FF",
              fontSize: "16px",
              color: "#000000",
              fontWeight: 700,
              borderRadius: "6px",
              paddingLeft: "10px"
            }}
            InputProps={{ readOnly: true }}
            value={value}
            onChange={onChange}
          />
        )}
      />
    </React.Fragment>
  );
};

const HeadLineCharacterCountCollapsItem = ({ average, control }) => {
  return (
    <React.Fragment>
      <Controller
        name="headlineCharacterCount"
        control={control}
        render={({ field: { value, onChange } }) => (
          <InputBase
            sx={{
              mt: 1,
              width:
                "60px",
              backgroundColor: "#F2E9FF",
              fontSize: "16px",
              color: "#000000",
              fontWeight: 700,
              borderRadius: "6px",
              paddingLeft: "10px"
            }}
            InputProps={{ readOnly: true }}
            value={value}
            onChange={onChange}
          />
        )}
      />
    </React.Fragment>
  );
};

const BodyCharacterCountCollapsItem = ({ average, control }) => {
  return (
    <React.Fragment>
      <Controller
        name="bodyCharacterCount"
        control={control}
        render={({ field: { value, onChange } }) => (
          <InputBase
            sx={{
              mt: 1,
              width: "60px",
              backgroundColor: "#F2E9FF",
              fontSize: "16px",
              color: "#000000",
              fontWeight: 700,
              borderRadius: "6px",
              paddingLeft: "10px"
            }}
            InputProps={{ readOnly: true }}
            value={value}
            onChange={onChange}
          />
        )}
      />
    </React.Fragment>
  );
};

const AssetsImageCountCollapsItem = ({ average, control }) => {
  return (
    <React.Fragment>
      <Controller
        name="image"
        control={control}
        render={({ field: { value, onChange } }) => (
          <InputBase
            sx={{
              mt: 1,
              width: "60px",
              backgroundColor: "#F2E9FF",
              fontSize: "16px",
              color: "#000000",
              fontWeight: 700,
              borderRadius: "6px",
              paddingLeft: "10px"
            }}
            InputProps={{ readOnly: true }}
            value={value}
            onChange={(e) => {
              const v = Number(e.target.value)
              onChange(v)
            }}
          />
        )}
      />
    </React.Fragment>
  );
};

const AssetsVideoCountCollapsItem = ({ average, control }) => {
  return (
    <React.Fragment>
      <Controller
        name="video"
        control={control}
        render={({ field: { value, onChange } }) => (
          <InputBase
            sx={{
              mt: 1,
              width: "60px",
              backgroundColor: "#F2E9FF",
              fontSize: "16px",
              color: "#000000",
              fontWeight: 700,
              borderRadius: "6px",
              paddingLeft: "10px"
            }}
            InputProps={{ readOnly: true }}
            value={value}
            onChange={(e) => {
              const v = Number(e.target.value)
              onChange(v)
            }}
          />
        )}
      />
    </React.Fragment>
  );
};

const DurationCollapsItem = ({ control }) => {
  return (
    <React.Fragment>
      <Controller
        name="duration"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FormControl size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={value}
              variant="outlined"
              onChange={onChange}
              sx={{
                backgroundColor: '#F2E9FF',
                border: 'none',
                borderRadius: "12px",
                fontSize: "16px", color: "#000000", fontWeight: 700,
                "& fieldset": { border: 'none' },
                "&:hover fieldset": { border: 'none' },
                "&.Mui-focused fieldset": { border: 'none' }
              }}
            >
              <MenuItem value={1} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>1 hour</MenuItem>
              <MenuItem value={2} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>2 hour</MenuItem>
              <MenuItem value={4} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>4 hour</MenuItem>
              <MenuItem value={8} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>8 hour</MenuItem>
              <MenuItem value={12} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>12 hour</MenuItem>
              <MenuItem value={24} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>1 day</MenuItem>
              <MenuItem value={48} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>2 days</MenuItem>
              <MenuItem value={96} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>4 days</MenuItem>
              <MenuItem value={168} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>1 week</MenuItem>
              <MenuItem value={336} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>2 weeks</MenuItem>
              <MenuItem value={730} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>1 month</MenuItem>
            </Select>
          </FormControl>
        )}
      />

    </React.Fragment>
  );
};

const ProximityCollapsItem = ({ control }) => {
  return (
    <React.Fragment>
      <Controller
        name="proximity"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FormControl size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={value}
              variant="outlined"
              onChange={onChange}
              sx={{
                backgroundColor: '#F2E9FF', // your custom background
                border: 'none',
                borderRadius: "12px",
                fontSize: "16px", color: "#000000", fontWeight: 700,
                "& fieldset": { border: 'none' }, // remove the outlined border
                "&:hover fieldset": { border: 'none' },
                "&.Mui-focused fieldset": { border: 'none' }
              }}
            >
              <MenuItem value={0.28} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>500yards</MenuItem>
              <MenuItem value={1} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>1mile</MenuItem>
              <MenuItem value={5} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>5mile</MenuItem>
              <MenuItem value={10} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>10mile</MenuItem>
              <MenuItem value={20} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>20mile</MenuItem>
              <MenuItem value={30} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>30mile</MenuItem>
            </Select>
          </FormControl>
        )} />

    </React.Fragment>
  );
};

const AdTypeCollapsItem = ({ control }) => {
  return (
    <React.Fragment>
      <Controller
        name="adType"
        control={control}
        render={({ field: { value, onChange } }) => (
          <FormControl size="small">
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              variant="outlined"
              value={value}
              onChange={onChange}
              sx={{
                backgroundColor: '#F2E9FF',
                border: 'none',
                borderRadius: "12px",
                fontSize: "16px",
                color: "#000000",
                fontWeight: 700,
                "& fieldset": { border: 'none' },
                "&:hover fieldset": { border: 'none' },
                "&.Mui-focused fieldset": { border: 'none' }
              }}
            >
              <MenuItem value={'instant_message'} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>instant message</MenuItem>
              <MenuItem value={'post only'} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>post only</MenuItem>
              <MenuItem value={'both'} sx={{ fontSize: "16px", color: "#000000", fontWeight: 700 }}>both</MenuItem>
            </Select>
          </FormControl>
        )} />
    </React.Fragment>
  );
};

const YourAdWillCost = ({ amount }) => {
  return (
    <React.Fragment>
      <InputBase sx={{ mt: 1, width: "140px", backgroundColor: "#F2E9FF", fontSize: "16px", color: "#000000", fontWeight: 700, borderRadius: "6px", paddingLeft: "10px" }} InputProps={{ readOnly: true }} value={`$ ${amount}`}></InputBase>
    </React.Fragment>
  );
};

const TestButtonForTable = ({ isLoading }) => {
  return (
    <ButtonStyle variant="contained" type="submit" loading={isLoading} loadingIndicator={<CircularProgress sx={{ color: "white" }} size={"18px"} />}>test</ButtonStyle>
  );
};

function createData(fast_marketing, price, average, component) {
  return {
    fast_marketing,
    price,
    average,
    component
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { border: "unset" } }}>
        <TableCell component="th" scope="row" sx={{ color: "#00000", fontSize: "14px", fontWeight: '800 !important' }}>
          {row.fast_marketing}
        </TableCell>
        <TableCell align="left" sx={{ color: "#00000", fontSize: "14px", fontWeight: '800 !important' }}>{!open && <>{row.price}</>}</TableCell>
        <TableCell align="left" sx={{ color: "#00000", fontSize: "14px", fontWeight: '800 !important' }}>
          {row.average &&
            <InputBase sx={{ mt: 1, width: "80px", backgroundColor: "#F2E9FF", fontSize: "18px", color: "#000000", fontWeight: 700, borderRadius: "6px", paddingLeft: "10px" }} InputProps={{ readOnly: true }} value={row.average}></InputBase>
          }
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.prototype = {
  row: PropTypes.shape({
    fast_marketing: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    average: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired,
  }).isRequired,
};



export default function CollapsibleTestModuleTable({ adSettingsTest, useAdPriceTestingForm, mutate, amount, isLoading }) {
  const {
    control,
    handleSubmit,
    errors,
  } = useAdPriceTestingForm();
  console.log('errors: ', errors);

  const onSubmit = async (data) => {
    return await mutate(data);
  }

  const rows = [
    createData("location count", <FastMarketingCollapsItem average={100} control={control} />, `${adSettingsTest?.location_count?.weightedAverage} %`),
    createData("headline character count", <HeadLineCharacterCountCollapsItem average={80} control={control} />, `${adSettingsTest?.headline_character_count?.weightedAverage} %`),
    createData("body character count", <BodyCharacterCountCollapsItem average={700} control={control} />, `${adSettingsTest?.body_character_count?.weightedAverage} %`),
    createData("duration", <DurationCollapsItem control={control} />, `${adSettingsTest?.duration?.weightedAverage} %`),
    createData("proximity targeting", <ProximityCollapsItem control={control} />, `${adSettingsTest?.proximity_targeting?.weightedAverage} %`),
    createData("ad type", <AdTypeCollapsItem control={control} />, `${adSettingsTest?.ad_type?.weightedAverage} %`),
    createData("image", <AssetsImageCountCollapsItem average={700} control={control} />, `${adSettingsTest?.asset_pricing?.weightedAverage} %`),
    createData("video", <AssetsVideoCountCollapsItem average={700} control={control} />, `${adSettingsTest?.asset_pricing?.weightedAverage} %`),
    createData(<TestButtonForTable control={control} isLoading={isLoading} />),
    createData("your ad will cost:", <YourAdWillCost amount={amount} control={control} />),
  ];

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TableContainer component={Paper} sx={{ overflowX: 'auto', display: 'block' }}>
        <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ width: "40%", color: "#6200EE", fontSize: "20px !important", fontWeight: '800 !important', textTransform: "lowercase" }}>
                fast marketing item
              </TableCell>
              <TableCell align="left" sx={{ width: "45%", color: "#6200EE", fontSize: "20px !important", fontWeight: '800 !important', textTransform: "lowercase" }}>
                quantity
              </TableCell>
              <TableCell align="left" sx={{ width: "15%", color: "#6200EE", fontSize: "20px !important", fontWeight: '800 !important', textTransform: "lowercase" }}>
                weighted average
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <Row key={index} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </form>
  );
}
